import { useCallback, useEffect } from 'react';
import { Metrics } from '../../utils/metrics';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TrackedButton } from 'growth-payments-core/usage-tracker/components/Button';
import { events } from 'growth-payments-core/usage-tracker/events';
import { EnrollmentFlowType } from '../../types';
import { useQueryStringState } from 'growth-payments-core/query-string/useQueryStringState';
import { getParentWindow } from 'growth-payments-core/query-string/utils';
import CelebrationModalV2 from './CelebrationModalV2';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEST_IDS = {
  KYC_PRE_APPROVAL_SUCCESS_MODAL_VERIFY: 'kyc-pre-approval-success-modal-verify',
  KYC_PRE_APPROVAL_SUCCESS_MODAL_GUIDE: 'kyc-pre-approval-success-modal-guide'
};
const PreApprovedApplicationSuccessModalV2 = ({
  businessTypeDetails,
  onClose,
  shouldReloadOnEnrollmentComplete = true,
  currentEnrollmentFlow
}) => {
  const [__, setCurrentEnrollmentFlow] = useQueryStringState('paymentsEnrollment', EnrollmentFlowType.processorPicker);
  const handleClick = useCallback(() => {
    setCurrentEnrollmentFlow(null);
    if (shouldReloadOnEnrollmentComplete) {
      getParentWindow().location.reload();
    } else {
      onClose();
    }
  }, [setCurrentEnrollmentFlow, shouldReloadOnEnrollmentComplete, onClose]);
  const {
    businessType,
    businessStructure
  } = businessTypeDetails;
  useEffect(() => {
    Metrics.counter('stripe-success-modal-viewed', {
      businessType: businessType || '',
      businessStructure: businessStructure || ''
    }).increment();
  }, [businessStructure, businessType]);
  const renderCta = useCallback(() => {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(TrackedButton, {
        event: events.paymentSettingsInteraction,
        trackingProperties: {
          action: 'gotoZeroStateButtonClicked',
          location: 'pre-approved-application-success-modal'
        },
        "data-test-id": TEST_IDS.KYC_PRE_APPROVAL_SUCCESS_MODAL_VERIFY,
        use: "primary",
        onClick: handleClick,
        children: shouldReloadOnEnrollmentComplete ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "preApprovedApplicationSuccessModal.primaryCta"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "preApprovedApplicationSuccessModal.continue"
        })
      }), shouldReloadOnEnrollmentComplete && /*#__PURE__*/_jsx(TrackedButton, {
        event: events.paymentSettingsInteraction,
        trackingProperties: {
          action: 'gotoGuideButtonClicked',
          location: 'pre-approved-application-success-modal'
        },
        "data-test-id": TEST_IDS.KYC_PRE_APPROVAL_SUCCESS_MODAL_GUIDE,
        use: "link",
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "preApprovedApplicationSuccessModal.secondaryCta"
        })
      })]
    });
  }, [handleClick, shouldReloadOnEnrollmentComplete]);
  const title = currentEnrollmentFlow === EnrollmentFlowType.stripe ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "preApprovedApplicationSuccessModal.headerStripe"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "preApprovedApplicationSuccessModal.headerNative"
  });
  const body = currentEnrollmentFlow === EnrollmentFlowType.stripe ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "preApprovedApplicationSuccessModal.bodyStripe"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "preApprovedApplicationSuccessModal.bodyNative"
  });
  return /*#__PURE__*/_jsx(CelebrationModalV2, {
    currentEnrollmentFlow: currentEnrollmentFlow,
    title: title,
    subTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "preApprovedApplicationSuccessModal.subTitle"
    }),
    bodyContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [body, shouldReloadOnEnrollmentComplete && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "preApprovedApplicationSuccessModal.goToCommerceOverview"
      })]
    }),
    testID: "kyc-success-modal",
    onClose: handleClick,
    primaryCTA: renderCta()
  });
};
export default PreApprovedApplicationSuccessModalV2;